/* shp- sections: sliders, tabs, before/after, hotspots, color changer, tracking, etc. */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function all(sel, root) {
    root = root || d;
    var list = Array.prototype.slice.call(root.querySelectorAll(sel));
    if (root !== d && root.matches && root.matches(sel)) list.unshift(root);
    return list;
  }
  function once(el, key) { if (el['_' + key]) return false; el['_' + key] = true; return true; }

  /* ---------- Slider (slideshow, hero slideshow, testimonials) ---------- */
  function initSlider(el) {
    if (!once(el, 'sl')) return;
    var track = el.querySelector('.shp-ss__track');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    if (!slides.length) return;
    var dots = all('[data-dot]', el), i = 0, timer = null;
    var auto = (parseFloat(el.getAttribute('data-auto')) || 0) * 1000;
    el.style.setProperty('--auto', (auto / 1000 || 6) + 's');
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (dt, k) { dt.classList.remove('is-active'); if (k === i) { void dt.offsetWidth; dt.classList.add('is-active'); } });
    }
    function play() { stop(); if (auto && !reduce && slides.length > 1) timer = setInterval(function () { if (!d.hidden) go(i + 1); }, auto); }
    function stop() { clearInterval(timer); }
    dots.forEach(function (dt, k) { dt.addEventListener('click', function () { go(k); play(); }); });
    var p = el.querySelector('[data-prev]'), n = el.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { go(i - 1); play(); });
    if (n) n.addEventListener('click', function () { go(i + 1); play(); });
    var sx = 0, sy = 0;
    el.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; stop(); }, { passive: true });
    el.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1));
      play();
    }, { passive: true });
    el.addEventListener('mouseenter', function () { el.classList.add('is-paused'); stop(); });
    el.addEventListener('mouseleave', function () { el.classList.remove('is-paused'); play(); });
    go(0); play();
  }

  /* ---------- Tabs ---------- */
  function initTabs(el) {
    if (!once(el, 'tb')) return;
    var btns = all('[role="tab"]', el), panels = all('[role="tabpanel"]', el);
    function show(k) {
      btns.forEach(function (b, j) { b.setAttribute('aria-selected', j === k ? 'true' : 'false'); b.tabIndex = j === k ? 0 : -1; });
      panels.forEach(function (p, j) { p.hidden = j !== k; });
    }
    btns.forEach(function (b, k) {
      b.addEventListener('click', function () { show(k); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { var nk = (k + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length; show(nk); btns[nk].focus(); }
      });
    });
    show(0);
  }

  /* ---------- Before / after ---------- */
  function initBA(el) {
    if (!once(el, 'ba')) return;
    var input = el.querySelector('input');
    function set() { el.style.setProperty('--pos', input.value + '%'); }
    input.addEventListener('input', set);
    set();
  }

  /* ---------- Rotating announcement bar ---------- */
  function initAB(el) {
    if (!once(el, 'ab')) return;
    var key = 'shp_ab_' + (el.getAttribute('data-id') || '');
    try { if (sessionStorage.getItem(key) === '1') { el.classList.add('is-closed'); return; } } catch (e) {}
    var msgs = all('.shp-ab__msg', el), i = 0;
    var every = (parseFloat(el.getAttribute('data-every')) || 4) * 1000;
    if (msgs.length) msgs[0].classList.add('is-active');
    if (msgs.length > 1) setInterval(function () {
      if (d.hidden) return;
      var cur = msgs[i];
      cur.classList.remove('is-active'); cur.classList.add('is-out');
      setTimeout(function () { cur.classList.remove('is-out'); }, 600);
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, every);
    var x = el.querySelector('.shp-ab__x');
    if (x) x.addEventListener('click', function () { el.classList.add('is-closed'); try { sessionStorage.setItem(key, '1'); } catch (e) {} });
  }

  /* ---------- 3D parallax hero: layers follow the mouse (or the phone's tilt via scroll) ---------- */
  function init3D(el) {
    if (!once(el, '3d') || reduce) return;
    var raf = 0, tx = 0, ty = 0;
    function apply() { raf = 0; el.style.setProperty('--mx', tx.toFixed(3)); el.style.setProperty('--my', ty.toFixed(3)); }
    el.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var r = el.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
      if (!raf) raf = requestAnimationFrame(apply);
    });
    el.addEventListener('pointerleave', function () { tx = ty = 0; if (!raf) raf = requestAnimationFrame(apply); });
    if (!(w.matchMedia && w.matchMedia('(hover: hover)').matches)) {
      w.addEventListener('scroll', function () {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        ty = Math.max(-1, Math.min(1, (r.top / innerHeight) * -2));
        tx = Math.sin(Date.now() / 1500) * 0.4;
        if (!raf) raf = requestAnimationFrame(apply);
      }, { passive: true });
    }
  }

  /* ---------- Shoppable hotspots ---------- */
  function initHot(el) {
    if (!once(el, 'ht')) return;
    all('.shp-hot', el).forEach(function (h) {
      h.querySelector('.shp-hot__dot').addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !h.classList.contains('is-open');
        all('.shp-hot.is-open', el).forEach(function (o) { o.classList.remove('is-open'); });
        h.classList.toggle('is-open', open);
      });
    });
    d.addEventListener('click', function (e) { if (!el.contains(e.target)) all('.shp-hot.is-open', el).forEach(function (o) { o.classList.remove('is-open'); }); });
  }

  /* ---------- Store colors changer (visitor picks a color; saved on their device) ---------- */
  function hexToRgb(h) {
    h = h.replace('#', '');
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function shade(rgb, f) { return 'rgb(' + rgb.map(function (v) { return Math.round(f < 0 ? v * (1 + f) : v + (255 - v) * f); }).join(',') + ')'; }
  function applyColor(main, second) {
    var root = d.documentElement.style;
    if (!main) { ['--c-primary', '--c-primary-rgb', '--c-primary-2', '--c-primary-2-rgb', '--c-primary-dark', '--c-primary-light'].forEach(function (v) { root.removeProperty(v); }); return; }
    var a = hexToRgb(main), b = hexToRgb(second || main);
    root.setProperty('--c-primary', main);
    root.setProperty('--c-primary-rgb', a.join(','));
    root.setProperty('--c-primary-2', second || main);
    root.setProperty('--c-primary-2-rgb', b.join(','));
    root.setProperty('--c-primary-dark', shade(a, -0.28));
    root.setProperty('--c-primary-light', shade(a, 0.18));
  }
  try { var saved = JSON.parse(localStorage.getItem('shp_color') || 'null'); if (saved && d.querySelector('[data-shp-colors]')) applyColor(saved[0], saved[1]); } catch (e) {}
  function initColors(el) {
    if (!once(el, 'cl')) return;
    var btn = el.querySelector('.shp-sc__btn');
    btn.addEventListener('click', function () { var o = el.classList.toggle('is-open'); btn.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    all('[data-c1]', el).forEach(function (s) {
      s.addEventListener('click', function () {
        var c1 = s.getAttribute('data-c1'), c2 = s.getAttribute('data-c2');
        applyColor(c1, c2);
        all('[data-c1]', el).forEach(function (o) { o.setAttribute('aria-pressed', o === s ? 'true' : 'false'); });
        try { localStorage.setItem('shp_color', JSON.stringify([c1, c2])); } catch (e) {}
      });
    });
    var r = el.querySelector('[data-reset]');
    if (r) r.addEventListener('click', function () { applyColor(null); try { localStorage.removeItem('shp_color'); } catch (e) {} all('[data-c1]', el).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); }); });
  }

  /* ---------- Track order: opens the courier's tracking page with the number ---------- */
  function initTrack(el) {
    if (!once(el, 'tr')) return;
    el.addEventListener('submit', function (e) {
      e.preventDefault();
      var num = (el.querySelector('input').value || '').trim();
      if (!num) return;
      var tpl = el.getAttribute('data-url') || '';
      var url = tpl.indexOf('[number]') > -1 ? tpl.replace('[number]', encodeURIComponent(num)) : tpl + encodeURIComponent(num);
      if (/^https?:\/\//i.test(url)) w.open(url, '_blank', 'noopener');
    });
  }

  /* ---------- Redirect section ---------- */
  function initRedirect(el) {
    if (!once(el, 'rd') || (w.Shopify && w.Shopify.designMode)) return;
    var to = el.getAttribute('data-to');
    if (!to || !/^(https?:\/\/|\/)/i.test(to)) return;
    setTimeout(function () { location.href = to; }, (parseFloat(el.getAttribute('data-delay')) || 0) * 1000);
  }

  /* ---------- Video with cover image ---------- */
  function initVideo(el) {
    if (!once(el, 'vd')) return;
    var btn = el.querySelector('.shp-vid__play');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var yt = el.getAttribute('data-yt'), vm = el.getAttribute('data-vimeo'), v = el.querySelector('video');
      if (yt || vm) {
        var f = d.createElement('iframe');
        f.src = yt ? 'https://www.youtube-nocookie.com/embed/' + yt + '?autoplay=1&rel=0&playsinline=1' : 'https://player.vimeo.com/video/' + vm + '?autoplay=1';
        f.allow = 'autoplay; encrypted-media; picture-in-picture';
        f.allowFullscreen = true;
        f.title = 'Video';
        el.appendChild(f);
      } else if (v) {
        v.controls = true; v.setAttribute('controlslist', 'nodownload');
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      el.classList.add('is-playing');
    });
  }

  /* ---------- Timeline progress line ---------- */
  var tls = [];
  function initTimeline(el) { if (once(el, 'tl')) tls.push(el); }
  function tlFrame() {
    tls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (innerHeight * 0.7 - r.top) / Math.max(1, r.height)));
      el.style.setProperty('--prog', (p * 100).toFixed(1) + '%');
    });
  }
  w.addEventListener('scroll', function () { if (tls.length) requestAnimationFrame(tlFrame); }, { passive: true });

  function initAll(root) {
    all('[data-shp-slider]', root).forEach(initSlider);
    all('[data-shp-tabs]', root).forEach(initTabs);
    all('[data-shp-ba]', root).forEach(initBA);
    all('[data-shp-ab]', root).forEach(initAB);
    all('[data-shp-3d]', root).forEach(init3D);
    all('[data-shp-hot]', root).forEach(initHot);
    all('[data-shp-colors]', root).forEach(initColors);
    all('[data-shp-track]', root).forEach(initTrack);
    all('[data-shp-redirect]', root).forEach(initRedirect);
    all('[data-shp-video]', root).forEach(initVideo);
    all('[data-shp-timeline]', root).forEach(initTimeline);
    tlFrame();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { initAll(d); });
  else initAll(d);
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
